/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, replacePXinStringWithEM, mediaQuery, nthChildIterator} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EXPORTBOX : STYLES --------------- ++++++++++ */
export default theme => ({
  '@global': {
    '.tippy-tooltip-content': {
      wordBreak: 'initial !important',
      textAlign: 'justify'
    },
  },
  exportbox: {
    background: theme.color.light.light.swatch,
    borderRadius: pxToEm(4),
    border: `1px solid #ECF0F7`,
    boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
    minWidth: pxToEm(150),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: pxToEm(10),
    padding: pxToEm(26),
    width: '100%',
    maxWidth: pxToEm(1146),
    minHeight: pxToEm(118),
    opacity: '0',
    animationName: 'fadeInUp',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    extend: nthChildIterator(100, .2, .1),
    transition: '0.3s',
    '&:hover': {
      boxShadow: theme.boxShadow.highlightCard
    },
    '& .exportboximg':{
      width: pxToEm(64),
      height: pxToEm(64)
    },
    '& .exportdescription':{
      paddingLeft: pxToEm(20),
      width: '100%',
      boxSizing: 'border-box',
      '& .title':{
        marginBottom: pxToEm(5),
        display: 'block',
        lineHeight: '160%',
        '& .titletip':{
          paddingLeft: pxToEm(5),
          '& .icon': {
            color: '#8295ba'
          }
        }
      },
      '& .subdescription': {
        fontWeight: 400,
        fontSize: pxToEm(14),
        lineHeight: '140%',
        color: '#abb2c3'
      }
    },
    '& .ctabutton': {
      '& .exportbutton' :{
        maxWidth: '138px',
        minHeight: '48px',
        fontSize: pxToEm(14),
        fontWeight: '500',
        lineHeight: '140%',
        fontFamily: '"Work Sans", sans-serif;'
      }
    }
  },

  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thinnest]: {
    exportbox: {
      textAlign: 'center',
      display: 'block',
      '& .exportboximg': {
        marginBottom: pxToEm(10)
      },
      '& .exportdescription':{
        marginBottom: pxToEm(10)
      }
    }
  }
});
